import { api } from '@/services/api/apiClient';
import {
  GetAllCandidatesResponse,
  GetInterviewResultResponse,
  CommonRequest,
} from './interviewResultsTypes';
import { API_ENDPOINTS } from '@/config';

export const interviewResultsService = {
  async getAllCandidates(
    request: CommonRequest
  ): Promise<GetAllCandidatesResponse> {
    return api.interviewAgent.post(
      API_ENDPOINTS.candidate.getAllCandidates,
      request
    );
  },

  async getInterviewResults(
    candidateUid: string,
    interviewUid?: string
  ): Promise<GetInterviewResultResponse> {
    const request: CommonRequest = {
      pageSize: 1000,
      filters: [{ fieldName: 'candidateUId', fieldValue: [candidateUid] }],
    };

    if (interviewUid) {
      request.filters?.push({ fieldName: 'uId', fieldValue: [interviewUid] });
    }

    return api.interviewAgent.post(
      API_ENDPOINTS.candidate.getAllInterviewResultData,
      request
    );
  },
};
